import React from 'react'

const NoInvoices: React.FC = () => {
  return (
    <div className="text-base text-gray-700 mt-2 text-center w-72">
      <span className="text-sm font-normal italic">
        No invoice are associated with this reservation.
      </span>
    </div>
  )
}

export default NoInvoices
